var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.session.group.key.includes('ROLE_SUPERADMIN','ROLE_ADMIN', 'ROLE_RESELLER'))?_c('financialDashboard'):_vm._e(),_vm._v(" "),(_vm.session.group.key.includes('ROLE_TERMINAL'))?_c('terminalDashboard'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72807b2f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Page.vue
// module id = 7m/v
// module chunks = 1